import uploadsaboutUsfeaturesAboutfeature01ImagelCole20238916CopyJpg from "$lib/data/generated/uploads/about us/Features About/Feature 01 Image/L-Cole-2023-8916-copy.jpg";

export const uploads = {
  "uploads/about us/Features About/Feature 01 Image/L-Cole-2023-8916-copy.jpg": uploadsaboutUsfeaturesAboutfeature01ImagelCole20238916CopyJpg
};